import * as React from 'react'
import { Box, Typography } from '@mui/material';
import {IconSeeker} from "@ui-seeker/core";

import { useStockAssortmentDetailsShowNotListed } from "../@hooks";

export default function retailerColumn() {
    return [{
		name: 'seller', label: 'Seller',
		options: {
			display: 'excluded',
		}
	},{
        name: 'seller', label: 'Seller',
        options: {
			headerAlign: 'left',
            filter: false,
            customBodyRowRenderLite: (value, {siteID, sellerID}) => <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', gap: 2 }}>
                <Typography variant='body2' sx={{ fontSize: '0.8rem'}}>{value}</Typography>
                <ShowNotListedCell siteID={siteID} sellerID={sellerID} /> 
            </Box>
        }
    }]
}

const ShowNotListedCell = ({siteID, sellerID}) => {
	const { handleClickShowNotListed } = useStockAssortmentDetailsShowNotListed(siteID, sellerID)

    return <Box sx={{ display: 'flex', alignItems: 'flex-end'}} onClick={handleClickShowNotListed}  >
        <IconSeeker icon={'file'} iconWeight={'light'} sx={{ mr: 0.5, margin: .5, color: 'primary.main'}}/>
		<Typography variant="caption" sx={{ display: 'block', color: "text.primary", mt: 1, mr: 0.5, cursor: 'pointer', "&:hover":{ textDecoration: 'underline'} }}>
            See Seller Assortment
        </Typography>
    </Box>

}